import React, { CSSProperties } from 'react';
import { Box, Preloader } from '@common-fe/common-fe';

import { Modal } from '@/components';

interface Props {
  visible: boolean;
  onSetVisible?: (value: boolean) => void;
  children?: React.ReactNode;
  testId?: string;
  style?: CSSProperties;
  contentStyle?: CSSProperties;
  isLoading?: boolean;
}
const PlaidModal: React.FC<Props> = ({
  children,
  onSetVisible,
  visible,
  testId,
  style,
  contentStyle,
  isLoading,
}) => (

  <Modal
    visible={visible}
    testId={testId}
    onSetVisible={onSetVisible}
    wrapperStyle={style}
    contentStyle={{
      width: '360px',
      height: '608px',
      ...contentStyle,
    }}
  >
    <Box direction="column">
      {isLoading && (
        <Box
          data-testId="plaid-modal-preloader"
          width="100%"
          height="608px"
          align="center"
          justify="center"
        >
          <Preloader />
        </Box>
      )}
      {children}
    </Box>
  </Modal>
);

export default PlaidModal;
